import {ColumnsPanelTrigger, ExportCsv, Toolbar, ToolbarButton} from "@mui/x-data-grid";
import RotateLeftOutlinedIcon from '@mui/icons-material/RotateLeftOutlined';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Tooltip from "@mui/material/Tooltip";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

export default function CustomToolbar({handleReset}) {
    return (
        <Toolbar>
            <Tooltip title="Columns">
                <ColumnsPanelTrigger render={<ToolbarButton/>}>
                    <ViewColumnIcon fontSize="small"/>
                </ColumnsPanelTrigger>
            </Tooltip>
            <Tooltip title="Reset Columns">
                <ToolbarButton
                    id="column-reset"
                    onClick={handleReset}
                >
                    <RotateLeftOutlinedIcon fontSize="small" sx={{ml: 'auto'}}/>
                </ToolbarButton>
            </Tooltip>
            <ExportCsv render={<ToolbarButton/>}>
                <FileDownloadIcon fontSize="small"/>
            </ExportCsv>
        </Toolbar>
    );
}